export const clearEmptyErrors = (errors: Record<string, string>) => {
    return Object.entries(errors).reduce((acc, [formKey, error]) => {
        if (error) {
            acc[formKey] = error;
        }
        return acc;
    }, {}) as {
        [key: string]: string;
    };
};
